import styles from './styles.scss';
import cn from 'classnames';
import { useToggle } from 'hooks';
import { LabeledInput } from 'components/Shared/Form/LabeledInput/themes/BGH';

interface RegInputProps {
  className?: string;
  type: string;
  change: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  placeholder: string;
  rule: (v: string) => string | undefined;
  focus?: () => void;
  blur?: () => void;
  errorMessage?: string | undefined;
  noPaddingLeft?: boolean;
  biggerFont?: boolean;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
}

export default function Input({
  className,
  type,
  change,
  value,
  placeholder,
  rule,
  focus,
  blur,
  errorMessage,
  noPaddingLeft,
  biggerFont,
  inputMode
}: RegInputProps) {
  const [active, toggleActive] = useToggle(false);

  let validMessage = rule(value);
  let valid = validMessage === undefined;
  let invalid = !valid && value !== '' && !active;

  if (errorMessage) {
    validMessage = errorMessage;
    valid = false;
    invalid = !active;
  }

  const internalBlur = () => {
    if (blur) {
      blur();
    }
    toggleActive(false);
  };
  const internalFocus = () => {
    if (focus) {
      focus();
    }
    toggleActive(true);
  };

  return (
    <div className={cn(styles.inputBase, className)}>
      <LabeledInput
        className={cn(styles.labeledInput, {
          [styles.invalid]: invalid
        })}
        type={type}
        value={value}
        placeholder={placeholder}
        label={placeholder}
        onChange={change}
        onBlur={internalBlur}
        onFocus={internalFocus}
        valid={valid}
        inputMode={inputMode}
      />
      {validMessage && invalid && (
        <p
          className={cn(styles.invalidMessage, {
            [styles.noPaddingLeft]: noPaddingLeft,
            [styles.biggerFont]: biggerFont
          })}
        >
          {validMessage}
        </p>
      )}
    </div>
  );
}
